import Vue from "vue";
import VueI18n from "vue-i18n";
import zh from "view-design/dist/locale/zh-CN";
import en from "view-design/dist/locale/en-US";
import TH from "view-design/dist/locale/en-US";
import cn from "../language/zh-CN";
import us from "../language/en-US";
import th from "../language/th-TH";

const messages = {
  "zh-CN": Object.assign(cn, zh),
  "en-US": Object.assign(us, en),
  "th-TH": Object.assign(th, TH)
};
Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: localStorage.getItem("language") || "th-TH",
  messages, // set locale messages
  silentTranslationWarn: true
});

export default i18n;
